import { useCart } from "apps/vtex/hooks/useCart.ts";
import Icon from "$store/components/ui/Icon.tsx";
import CartItem from "$store/components/header/minicart/CartItem.tsx";
import FreeShippingProgressBar from "$store/components/header/minicart/FreeShippingProgressBar.tsx";

interface Props {
  freeShippingTarget?: number;
}

export default function Items({ freeShippingTarget = 250 }: Props) {
  const { cart } = useCart();
  const isCartEmpty = cart.value?.items.length === 0;
  const totalizers = cart.value?.totalizers;
  const locale = cart.value?.clientPreferencesData.locale;
  const currencyCode = cart.value?.storePreferencesData.currencyCode;
  const total = totalizers?.find((item) => item.id === "Items")?.value || 0;

  if (cart.value === null) return null;

  return (
    isCartEmpty
      ? (
        <div class="w-full h-full px-7 mb-20 grid justify-items-center content-center">
          <Icon
            id="Cart"
            class="mb-5 text-tw-primary-100"
            width={61}
            height={54}
          />

          <span class="text-tw-neutral-500 text-2xl text-center font-maven font-extrabold">
            Sua sacola está vazia
          </span>

          <span class="max-w-[15.5rem] text-tw-neutral-500 text-sm text-center">
            Aproveite nossas ofertas e promoções para encher sua sacola de
            delícias!
          </span>

          <label
            class="w-full h-12 mt-9 rounded-lg bg-tw-neutral-400 text-white text-xl font-bold flex justify-center items-center cursor-pointer transition-colors duration-300 hover:bg-tw-neutral-500"
            htmlFor="minicart-drawer"
          >
            Voltar às compras
          </label>
        </div>
      )
      : (
        <>
          <ul
            role="list"
            class="my-4 mx-4 divide divide-y divide-tw-neutral-100 overflow-y-auto overflow-x-hidden flex-grow grid content-start scrollbar"
          >
            {cart.value?.items.map((_, index) => (
              <CartItem
                index={index}
                currency={currencyCode!}
                locale={locale!}
              />
            ))}
          </ul>

          {freeShippingTarget && (
            <FreeShippingProgressBar
              total={total / 100}
              target={freeShippingTarget}
              locale={locale!}
              currency={currencyCode!}
            />
          )}
        </>
      )
  );
}
